import React from "react";
import user from "../../assets/images/user.png";

const Participant = () => {
	return (
		<div className="w-full">
			<div className="rounded-lg mb-2 pr-1 tab-bar overflow-y-auto max-h-96">
				<div className="flex items-center justify-between py-1 my-1 gap-x-2 text-right border border-slate-600">
					<div className="flex items-center gap-1 pl-1">
						<img
							src={user}
							alt="Main user"
							className="w-12 h-12 p-1 mr-1 rounded-full border border-slate-600"
						/>
						<h2 className="text-md font-medium">Md. Hasan Mia</h2>
					</div>
					<div className="flex items-center gap-2 pr-1">
						<i className="fal fa-microphone font-bold text-sm text-gray-200 bg-slate-600 p-1 bottom-4 right-4 rounded-md"></i>
						<i className="fal fa-video font-bold text-sm text-gray-200 bg-slate-600 p-1 bottom-4 right-4 rounded-md"></i>
					</div>
				</div>
				<div className="flex items-center justify-between py-1 my-1 gap-x-2 text-right border border-slate-600">
					<div className="flex items-center gap-1 pl-1">
						<img
							src={user}
							alt="Main user"
							className="w-12 h-12 p-1 mr-1 rounded-full border border-slate-600"
						/>
						<h2 className="text-md font-medium">Md. Hasan Mia</h2>
					</div>
					<div className="flex items-center gap-2 pr-1">
						<i className="fal fa-microphone font-bold text-sm text-gray-200 bg-slate-600 p-1 bottom-4 right-4 rounded-md"></i>
						<i className="fal fa-video font-bold text-sm text-gray-200 bg-slate-600 p-1 bottom-4 right-4 rounded-md"></i>
					</div>
				</div>
				<div className="flex items-center justify-between py-1 my-1 gap-x-2 text-right border border-slate-600">
					<div className="flex items-center gap-1 pl-1">
						<img
							src={user}
							alt="Main user"
							className="w-12 h-12 p-1 mr-1 rounded-full border border-slate-600"
						/>
						<h2 className="text-md font-medium">Md. Hasan Mia</h2>
					</div>
					<div className="flex items-center gap-2 pr-1">
						<i className="fal fa-microphone font-bold text-sm text-gray-200 bg-slate-600 p-1 bottom-4 right-4 rounded-md"></i>
						<i className="fal fa-video font-bold text-sm text-gray-200 bg-slate-600 p-1 bottom-4 right-4 rounded-md"></i>
					</div>
				</div>

				<div className="flex items-center justify-between py-1 my-1 gap-x-2 text-right border border-slate-600">
					<div className="flex items-center gap-1 pl-1">
						<img
							src={user}
							alt="Main user"
							className="w-12 h-12 p-1 mr-1 rounded-full border border-slate-600"
						/>
						<h2 className="text-md font-medium">Md. Hasan Mia</h2>
					</div>
					<div className="flex items-center gap-2 pr-1">
						<i className="fal fa-microphone font-bold text-sm text-gray-200 bg-slate-600 p-1 bottom-4 right-4 rounded-md"></i>
						<i className="fal fa-video font-bold text-sm text-gray-200 bg-slate-600 p-1 bottom-4 right-4 rounded-md"></i>
					</div>
				</div>

				<div className="flex items-center justify-between py-1 my-1 gap-x-2 text-right border border-slate-600">
					<div className="flex items-center gap-1 pl-1">
						<img
							src={user}
							alt="Main user"
							className="w-12 h-12 p-1 mr-1 rounded-full border border-slate-600"
						/>
						<h2 className="text-md font-medium">Md. Hasan Mia</h2>
					</div>
					<div className="flex items-center gap-2 pr-1">
						<i className="fal fa-microphone font-bold text-sm text-gray-200 bg-slate-600 p-1 bottom-4 right-4 rounded-md"></i>
						<i className="fal fa-video font-bold text-sm text-gray-200 bg-slate-600 p-1 bottom-4 right-4 rounded-md"></i>
					</div>
				</div>

				<div className="flex items-center justify-between py-1 my-1 gap-x-2 text-right border border-slate-600">
					<div className="flex items-center gap-1 pl-1">
						<img
							src={user}
							alt="Main user"
							className="w-12 h-12 p-1 mr-1 rounded-full border border-slate-600"
						/>
						<h2 className="text-md font-medium">Md. Hasan Mia</h2>
					</div>
					<div className="flex items-center gap-2 pr-1">
						<i className="fal fa-microphone font-bold text-sm text-gray-200 bg-slate-600 p-1 bottom-4 right-4 rounded-md"></i>
						<i className="fal fa-video font-bold text-sm text-gray-200 bg-slate-600 p-1 bottom-4 right-4 rounded-md"></i>
					</div>
				</div>

				<div className="flex items-center justify-between py-1 my-1 gap-x-2 text-right border border-slate-600">
					<div className="flex items-center gap-1 pl-1">
						<img
							src={user}
							alt="Main user"
							className="w-12 h-12 p-1 mr-1 rounded-full border border-slate-600"
						/>
						<h2 className="text-md font-medium">Md. Hasan Mia</h2>
					</div>
					<div className="flex items-center gap-2 pr-1">
						<i className="fal fa-microphone font-bold text-sm text-gray-200 bg-slate-600 p-1 bottom-4 right-4 rounded-md"></i>
						<i className="fal fa-video font-bold text-sm text-gray-200 bg-slate-600 p-1 bottom-4 right-4 rounded-md"></i>
					</div>
				</div>
				<div className="flex items-center justify-between py-1 my-1 gap-x-2 text-right border border-slate-600">
					<div className="flex items-center gap-1 pl-1">
						<img
							src={user}
							alt="Main user"
							className="w-12 h-12 p-1 mr-1 rounded-full border border-slate-600"
						/>
						<h2 className="text-md font-medium">Md. Hasan Mia</h2>
					</div>
					<div className="flex items-center gap-2 pr-1">
						<i className="fal fa-microphone font-bold text-sm text-gray-200 bg-slate-600 p-1 bottom-4 right-4 rounded-md"></i>
						<i className="fal fa-video font-bold text-sm text-gray-200 bg-slate-600 p-1 bottom-4 right-4 rounded-md"></i>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Participant;
